export default __webpack_public_path__ + "static/media/socicon.ec23f2c6.eot";